<template>
  <div class='ip-node-properties'>
    <div class='ip-node-properties__header'>
      <div>
        <v-icon>location_on</v-icon>
      </div>
      <div class='ip-node-properties__header__title'>
        <div class='ip-node-properties__header__title__name'>
          {{name}}
        </div>
        <div class='ip-node-properties__header__title__type'>
          {{$t(`ctc.properties.type.${data.type.toLowerCase()}`)}}
        </div>
      </div>
    </div>
    <v-expansion-panels multiple v-model="panels" flat>
      <!-- ASN Panel -->
      <v-expansion-panel>
        <v-expansion-panel-header class='panel-header'>{{$t('ctc.properties.asn.title')}}</v-expansion-panel-header>
        <v-expansion-panel-content>
          <div class="asn-content" v-if="data.asn">
            <div class="asn-row">
              <div class="asn-label">{{$t('host.asn.popup.org')}}</div>
              <div class="asn-value">{{data.asn.org}}</div>
            </div>
            <div class="asn-row">
              <div class="asn-label">{{$t('host.asn.popup.asn')}}</div>
              <div class="asn-value">{{data.asn.asn}}</div>
            </div>
            <div class="asn-row">
              <div class="asn-label">{{$t('host.asn.popup.network')}}</div>
              <div class="asn-value">{{data.asn.network}}</div>
            </div>
            <div class="asn-row">
              <div class="asn-label">{{$t('host.asn.popup.country.name')}}</div>
              <div class="asn-value">{{data.asn.country_name}}</div>
            </div>
            <div class="asn-row">
              <div class="asn-label">{{$t('host.asn.popup.region')}}</div>
              <div class="asn-value">{{data.asn.region}}</div>
            </div>
            <div class="asn-row">
              <div class="asn-label">{{$t('host.asn.popup.city')}}</div>
              <div class="asn-value">{{data.asn.city}}</div>
            </div>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <!-- Ports Panel -->
      <v-expansion-panel>
        <v-expansion-panel-header class='panel-header'>{{$t('ctc.properties.ports.title')}}</v-expansion-panel-header>
        <v-expansion-panel-content>
          <div class="ports-content" v-if="data.ports && data.ports.length">
            <div class="ports-row" v-for="(port, index) in data.ports" :key="index">
              <div class="port-value">{{port}}</div>
            </div>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>
<script>
export default {
  name: 'IPNodeProperties',
  props: {
    data: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  data() {
    return {
      panels: [0, 1],
    };
  },
  computed: {
    name() {
      return this.data.name;
    },
  },
};
</script>
<style scoped lang='scss'>
@import '~@/assets/styles/design-system';
.ip-node-properties{
  display: flex;
  flex-direction: column;
  margin-top: rem(15);
  &__header{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    margin-left: rem(10);
    &__title{
      display: flex;
      flex-direction: column;
      margin-left: rem(15);
      &__name{
        color: var(--text-primary);
        font-family: $font-family-regular;
        font-size: rem(16);
        font-weight: bold;
        letter-spacing: 0;
        line-height: rem(17);
      };
      &__type{
        color: var(--text-tertiary);
        font-family: $font-family-regular;
        font-size: rem(10);
        letter-spacing: 1.1px;
        line-height: rem(15);
        margin-top: rem(5);
        text-transform: uppercase;
      };
    };
  }
  .panel-header {
    color: var(--text-primary);
    font-family: $font-family-medium;
    font-size: rem(14);
    letter-spacing: 0;
    line-height: rem(17);
    text-transform: uppercase;
  }
  .asn-content, .ports-content {
    padding: rem(10);
  }

  .asn-row, .ports-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: rem(8);

  }

  .asn-label {
    min-width: rem(100);
    color: var(--text-tertiary);
    font-family: $font-family-regular;
    font-size: rem(10);
    letter-spacing: 1.1px;
    text-transform: uppercase;
    align-items: center;

  }

  .asn-value, .port-value {
    color: var(--text-primary);
    font-family: $font-family-regular;
    font-size: rem(10);
    align-items: center;
  }
}
</style>
